module.exports = __webpack_public_path__ + "ios_icon.png?4e58f8142b4b358293b0232f11a4b2e1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ios_icon.png
// module id = 393
// module chunks = 0